// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MiniProgramSvg from '@rsuite/icon-font/lib/platform/MiniProgram';
var MiniProgram = createSvgIcon({
  as: MiniProgramSvg,
  ariaLabel: 'mini program',
  category: 'platform',
  displayName: 'MiniProgram'
});
export default MiniProgram;